/**
 * Stats Block.
 */
import inView from 'in-view';

const ProgressBar = require('progressbar.js');
const { CountUp } = require('../plugins/countup.js');

const initStatsBlocks = () => {
	// Get all chart percentages stat blocks.
	const statsBlocks = document.querySelectorAll('.em-stat.is-chart');
	const progressbarHtml = (statsLabel, statsPercentage) => `<p><span class="em-stat-percentage">${statsPercentage}%</span></p><p><span class="em-stat-label">${statsLabel}</span></p>`;

	// Only proceed if chart blocks have been found.
	if (statsBlocks) {
		statsBlocks.forEach((stat) => {
			// Don't initiate the animation until the chart stat block(s) are in view
			const statId = stat.getAttribute('id');
			inView(`#${statId}`).once('enter', (stat) => {
				const percent = stat.getAttribute('data-percentage');
				const percentageFinal = percent ? parseFloat(parseInt(percent)) / 100.0 : 0.50;
				const label = stat.getAttribute('data-label');
				// const definedSeparator = stat.getAttribute('data-separator');

				const bar = new ProgressBar.Circle(stat, {
					color: '#aaa',
					// This has to be the same size as the maximum width to
					// prevent clipping
					strokeWidth: 5,
					trailWidth: 5,
					easing: 'easeInOut',
					duration: 1400,
					text: {
						autoStyleContainer: false,
					},
					// Set default step function for all animate calls
					step(state, circle) {
						const value = Math.round(circle.value() * 100);
						if (value === 0) {
							circle.setText(progressbarHtml(label, 0));
						} else {
							circle.setText(progressbarHtml(label, value));
						}
					},
				});
				bar.animate(percentageFinal); // Number from 0.0 to 1.0
			});
		});
	}

	// Get all number / unit stat blocks.
	const statsBlocksNumbers = document.querySelectorAll('.em-stat.is-number');

	// Only proceed if Number / Unit Stat blocks have been found.
	if (statsBlocksNumbers) {
		statsBlocksNumbers.forEach((stat) => {
			// Don't initiate the animation until the number / unit stat block(s) are in view.
			const statId = stat.getAttribute('id');
			inView(`#${statId}`).once('enter', (stat) => {
				const numberContainer = stat.querySelector('.em-stat-number');
				const statsNumber = numberContainer.getAttribute('data-number');
				const statsSeparator = numberContainer.getAttribute('data-separator');
				const statsDecimal = statsNumber.indexOf('.');
				let decimalPlaces = 0;
				let separator = ',';

				if (statsDecimal > 0)	{
					decimalPlaces = statsNumber.length - statsDecimal - 1;
				}

				if (statsSeparator) {
					separator = statsSeparator;
				}

				const countUpOptions = {
					decimalPlaces,
					separator,
				};

				const countUp = new CountUp(numberContainer, statsNumber, countUpOptions);
				countUp.start();
			});
		});
	}
};

window.addEventListener('DOMContentLoaded', initStatsBlocks);
